import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import { routes } from 'constants/config';

class BackButton extends Component {
  render() {
    return (
      <Link
        to={this.props.sourcePage || routes.LEARN}
        className="LearnBackButton u-linkBtn"
      >
        <Icon name="back" className="LearnBackButton-icon" />
        {t('common.back')}
      </Link>
    );
  }
}

const mapStateToProps = state => ({
  sourcePage: state.search.sourcePage,
});

export default compose(withRouter, connect(mapStateToProps))(BackButton);
